import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

class UserApi {
	static getBaseURL() {
        return localStorage.apiDomain || config.api;
    }

	static getInstance() {
        const instance = axios.create({
            baseURL: this.getBaseURL(),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return instance;
    }

	static UserConfirmPassword(payload) {
		const userInstance = this.getInstance();
		return userInstance.post('/auth/login', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserLogin(payload) {
		const userInstance = this.getInstance();
		let path = (payload.auth_token)?'/auth/oAuth':'/auth/login';
		return userInstance.post(path, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserInsert(payload) {
		const userInstance = this.getInstance();
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return userInstance.post(`/users`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserUpdate(payload, id) {
		const userInstance = this.getInstance();
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.patch(`/users/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserList(data) {
		const userInstance = this.getInstance();
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return userInstance.get(`/users?organization=`+data)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static UserDelete(payload) {
		const userInstance = this.getInstance();
		userInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return userInstance.post(`/auth/delete`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}


}

export default UserApi;
